export enum PromoCodeAssignmentType {
  GENERAL = 'general',
  PERSONAL = 'personal',
}

export enum PromoCodeSourceType {
  ADMIN = 'admin',
  REFERRAL = 'referral',
}

export enum PromoCodeEffectType {
  SET_PERCENT = 'set_percent',
  DISCOUNT_PERCENT = 'discount_percent',
}

export enum PromoCodeOperationType {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
  BOTH = 'both',
}
